import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

/*
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2020-12-21 09:49:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-12-21 18:23:32
 * @FilePath: \heshan_web\src\router\axios.js
 */

/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 * isToken是否需要token
 */
import axios from 'axios';
import store from '@/store/';
import router from '@/router/router';
import { serialize } from '@/util/util';
import { getToken, getRefreshToken } from '@/util/auth';
import { Message } from 'element-ui';
import website from '@/config/website';
import { Base64 } from 'js-base64';
import NProgress from 'nprogress';
import { getStore } from '@/util/store';
import 'nprogress/nprogress.css'; //默认超时时间

axios.defaults.timeout = 40000; //返回其他状态码

axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500;
}; //跨域请求，允许保存cookie


axios.defaults.withCredentials = true; // NProgress 配置

NProgress.configure({
  showSpinner: false
}); //http request拦截

axios.interceptors.request.use(function (config) {
  //开启 progress bar
  // NProgress.start();
  var meta = config.meta || {};
  var isToken = meta.isToken === false; // 当请求为onet时 不要传authorization 

  if (config.url.indexOf("http://onenet.zn.thingcom.com/") == -1 && config.url.indexOf("https://picture.thingcom.cn/") == -1) {
    config.headers['Authorization'] = "Basic ".concat(Base64.encode("".concat(website.clientId, ":").concat(website.clientSecret)));
  } //让每个请求携带token


  if (getToken() && !isToken) {
    if (config.url.indexOf("http://onenet.zn.thingcom.com/") == -1 && config.url.indexOf("https://picture.thingcom.cn/web") == -1) {
      config.headers[website.tokenHeader] = 'bearer ' + getToken();
      config.headers['tenantId'] = getStore({
        name: 'tenantId'
      }) || '';
    }
  } //headers中配置text请求


  if (config.text === true) {
    config.headers["Content-Type"] = "text/plain";
  }

  config.headers["languageType"] = getStore({
    name: 'language'
  }) || 'zh'; //headers中配置serialize为true开启序列化

  if (config.method === 'post' && meta.isSerialize === true) {
    config.data = serialize(config.data);
  }

  return config;
}, function (error) {
  return Promise.reject(error);
}); //http response 拦截

axios.interceptors.response.use(function (res) {
  //关闭 progress bar
  // NProgress.done();
  //获取状态码
  var status = res.data.code || res.status;
  var statusWhiteList = website.statusWhiteList || [];
  var message = res.data.msg || res.data.error_description || '未知错误'; //如果在白名单里则自行catch逻辑处理

  if (statusWhiteList.includes(status)) return Promise.reject(res); //如果是401则跳转到登录页面

  if (status === 401) store.dispatch('FedLogOut').then(function () {
    return router.push({
      path: '/login'
    });
  }); // 如果请求为非200否者默认统一处理

  if (status !== 200) {
    Message({
      message: message,
      type: 'error'
    });
    return Promise.reject(new Error(message));
  }

  return res;
}, function (error) {
  // NProgress.done();
  return Promise.reject(new Error(error));
});
export default axios;